<template>
    <v-app>
        <div v-if="shouldDisplayLoader">
            <app-dialogLoader></app-dialogLoader>
        </div>

        <div v-else>
            <transition name="slide-x-transition" mode="out-in">
                <router-view name="header"></router-view>
            </transition>

            <v-content>
                <v-container fluid class="pt-5">
                    <transition name="slide-x-transition" mode="out-in">
                        <router-view></router-view>
                    </transition>
                    <app-Event></app-Event>
                </v-container>
            </v-content>
        </div>
    </v-app>
</template>

<style lang="stylus">
@import './stylus/main';
</style>

<script>
import Event from '@/components/shared/Event';
import DialogLoader from '@/components/shared/DialogLoader';

export default {
    computed: {
        shouldDisplayLoader() {
            return this.$store.getters.isStoreInitializing;
        },
    },

    components: {
        appDialogLoader: DialogLoader,
        appEvent: Event,
    },
};
</script>



// WEBPACK FOOTER //
// src/App.vue